import axios from "axios";
import { getHeaders, URL } from "./config";
export const getQuotesApi = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/getShippingQuotes`;
  axios
    .post(url, data, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error });
    });
};
export const createUpsLabelApi = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/createUPSLabel`;
  axios
    .post(url, data, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.message });
    });
};
export const createUspsLabelApi = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/createUSPSLabel`;
  axios
    .post(url, data, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.message });
    });
};
export const createFedexLabelApi = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/createFedexLabel`;
  axios
    .post(url, data, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      } else {
        // callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.response?.data });
    });
};
export const createFedexReturnLabelApi = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/createFedexReturnLabel`;
  axios
    .post(url, data, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.message });
    });
}
export const createUPSReturnLabelApi = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/createUPSReturnLabel`;
  axios
    .post(url, data, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.message });
    });
}
